// extracted by mini-css-extract-plugin
module.exports = {"main":"ingredient-details-page_main__3096E"};